export default __webpack_public_path__ + "static/Marketing_ Segmentation-750fbf0913742c34848e63841a249bea.svg";